import React from 'react';
import { motion } from 'framer-motion';
import { CirculatingSupplyBars } from '@/components/charts/CirculatingSupplyBars';

export const TGESupplySection = () => {
  return (
    <section id="tge" className="py-24 relative">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background" />
      <div className="absolute top-0 left-0 right-0 h-px neural-line" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-primary text-sm font-medium tracking-wider uppercase">
            Circulating Supply
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mt-3 mb-4">
            Supply at Token Generation Event
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            80% of $NEURO tokens will be circulating at TGE, ensuring high liquidity 
            and preventing manipulation by any single party.
          </p>
        </motion.div>
        
        {/* Circulating Supply Chart */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <CirculatingSupplyBars />
        </motion.div>
        
        {/* Neural line separator */}
        <div className="mt-24 neural-line" />
      </div>
    </section>
  );
};

export default TGESupplySection;
